module.exports = {"130431100":"鸡泽镇","130431101":"小寨镇","130431102":"双塔镇","130431103":"曹庄镇","130431200":"浮图店乡","130431201":"吴官营乡","130431202":"风正乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130431.json
// module id = 124
// module chunks = 0